var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CustomInput } from 'reactstrap';
import { mapToCssModules } from '../../utils/className';
export const SmlsSwitch = (_a) => {
    var { id, dark, className, checked, onClick } = _a, params = __rest(_a, ["id", "dark", "className", "checked", "onClick"]);
    return (React.createElement(CustomInput, Object.assign({ id: id, type: "switch", className: mapToCssModules([className || '', dark ? 'dark' : '']), checked: checked, onClick: onClick }, params),
        React.createElement("div", { className: "smls-switch-out" })));
};
//# sourceMappingURL=index.js.map